"use client";

import { handleError } from "@idss/notification";
import { Flex, Image, Stack, Text } from "@mantine/core";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";

import { useFileUpload } from "@/hooks/use-file-upload";
import { UploadSampleIcon } from "@/svgs/upload-sample-icon";

import { useFormContext } from "./edit-profile-form-context";

interface ProfileImageProps {
  url?: string;
}

export function ProfileImage({ url }: ProfileImageProps) {
  const form = useFormContext();

  const { preview, handleUpload } = useFileUpload({
    key: "profile-image",
    onError: () => {
      handleError({
        message: "Failed to upload thumbnail",
      });
    },
    onSuccess: ({ data }) => {
      form.clearFieldError("thumbnail_id");
      form.setFieldValue("thumbnail_id", data.id);
    },
  });
  return (
    <Stack p={24} gap={8} className="border border-primary-border-light">
      <Dropzone
        accept={IMAGE_MIME_TYPE}
        onDrop={handleUpload}
        disabled={!form.values.edit_profile}
      >
        <Stack
          pos="relative"
          justify="end"
          w={155}
          className="cursor-pointer aspect-square"
        >
          <Image
            fit="cover"
            src={preview.url || url}
            alt={preview.name}
            pos="absolute"
            inset={0}
            h="100%"
          />
          <Flex
            gap={5}
            p={10}
            pos="relative"
            className="bg-black/50"
            justify="center"
            align="center"
          >
            <UploadSampleIcon />
            <Text className="prose-xs/regular text-primary-background-white">
              Upload Photo
            </Text>
          </Flex>
        </Stack>
      </Dropzone>

      <Text className="prose-xs/regular text-gray-11 text-center max-w-[156px]">
        Image size should be under 1MB and image ration needs to be 1:1
      </Text>
    </Stack>
  );
}
